import './index.css';
import { useRef, useEffect } from 'react';

const useOTP = (callback, credentialsRequestId, onCredetialsRequestFail) => {
    const callbackRef = useRef(callback);
    const onFailCallbackRef = useRef(onCredetialsRequestFail);
    callbackRef.current = callback;
    onFailCallbackRef.current = onCredetialsRequestFail;
    useEffect(() => {
        if (!('OTPCredential' in window)) {
            return undefined;
        }
        const ac = new AbortController();
        navigator.credentials
            .get({
            otp: { transport: ['sms'] },
            signal: ac.signal,
        })
            // ts не знает о типе OTPCredentials
            .then((otp) => callbackRef.current(otp?.code))
            .catch((error) => {
            onFailCallbackRef.current?.(error);
        });
        return () => {
            ac.abort();
        };
    }, [credentialsRequestId]);
};

export { useOTP };
//# sourceMappingURL=useOTP.js.map
